import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';

import { Packshot } from "../../models/packshot.model";

import { LoginPage } from '../auth/login';

import { API_URL } from "../../providers/api-url";

import { fadeInOutAnimation } from '../../animations/fade-in-out';

@IonicPage()
@Component({
  selector: 'page-packshots',
  templateUrl: 'packshots.html',
  animations: [
    fadeInOutAnimation
  ]
})
export class PackshotsPage {

  packshots: Packshot[];

  constructor(public navCtrl: NavController, public navParams: NavParams, private iab: InAppBrowser) {
    this.packshots = this.navParams.get('packshots');
  }

  toInt(s: string) {
    return parseInt(s);
  }

  download(packshot: Packshot) {
    this.iab.create(`${API_URL}/packshots/download/${packshot.id}`, '_system', 'location=no');
  }

  disconnected() {
    this.navCtrl.setRoot(LoginPage, {
      disconnected: true
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/packshots/packshots.ts